import React, { useState } from "react"
import { FiArchive, FiAtSign, FiBold, FiChevronDown, FiChevronRight, FiCode, FiEdit2, FiFileText, FiHeadphones, FiItalic, FiLink, FiList, FiLogOut, FiMenu, FiMic, FiMoreVertical, FiPaperclip, FiPlus, FiSearch, FiSettings, FiSmile, FiTrash2, FiType, FiUser, FiUserPlus, FiUsers, FiVideo, FiVolume1, FiVolume2, FiVolumeX, FiX, FiZap } from "react-icons/fi"
import clx from "classnames"
import { teamChannels } from "../../../../dummy/users"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHashtag } from '@fortawesome/free-solid-svg-icons'
import { useModal } from "../../../../stores/useModal"
import teamStore from "../../../../stores/useTeam"

export const Sidebar = ({mobile}) => {
    const {open} = useModal(state=>state)
    return (
        <React.Fragment>
            <div className={clx(
                !mobile ? 'hidden lg:flex' : 'flex w-screen text-white',
                'sidebar lg:col-span-3 flex scrollbar-invisible'
            )}>
                    <div className="overflow-y-auto dark:bg-[#181a1c] h-screen bg-gray-200 p-3">
                        <ul className="grid gap-4">
                        <li>
                            <div
                            onClick={()=>open({type:'create-group'})}
                            className="cursor-pointer h-12 w-12 bg-gray-200 dark:bg-zinc-700 rounded-md text-center text-white flex items-center justify-center text-3xl"
                            >
                            <FiPlus size={23} className="h-6 text-gray-500 stroke-4" /> 
                            </div>
                        </li>
                        <li className="text-center">
                            <div className="cursor-pointer h-12 w-12 bg-green-400 rounded-full text-center text-white flex items-center justify-center text-3xl">A</div>
                            <p className="text-[9px] my-2 dark:text-zinc-400">15 ONLINE</p>
                            <div className="mt-1 h-[1.5px] w-full bg-gray-200 dark:bg-zinc-700"></div>
                        </li>
                        <li>
                            <div className="cursor-pointer h-12 w-12 bg-green-400 rounded-full text-center text-white flex items-center justify-center text-3xl">D</div>
                        </li>
                        <li className="relative">
                            <div className="absolute h-6 w-1.5 bg-gray-500 rounded-full -left-2.5 top-[30%]"></div>
                            <div className="cursor-pointer h-12 w-12 bg-green-400 rounded-md text-center text-white flex items-center justify-center text-3xl">
                            <p className="opacity-80">M</p>
                            </div>
                        </li>
                        <li className="relative">
                            <div className="absolute h-2 w-2 bg-gray-500 rounded-full -left-2.5 top-[45%]"></div>
                            <div className="cursor-pointer h-12 w-12 bg-blue-300 rounded-full text-center text-white flex items-center justify-center text-3xl">B</div>
                        </li>
                        <li>
                            <div className="cursor-pointer h-12 w-12 bg-orange-400 rounded-full text-center text-white flex items-center justify-center text-3xl">7</div>
                        </li>
                        <li>
                            <div className="cursor-pointer h-12 w-12 bg-yellow-400 rounded-full text-center text-white flex items-center justify-center text-3xl">B</div>
                        </li>
                        <li>
                            <div className="cursor-pointer h-12 w-12 bg-pink-500 rounded-full text-center text-white flex items-center justify-center text-3xl">
                            <p className="opacity-80">R</p>
                            </div>
                        </li>
                        <li>
                            <div className="cursor-pointer h-12 w-12 bg-green-500 rounded-full text-center text-white flex items-center justify-center text-3xl">
                            <p className="opacity-80">D</p>
                            </div>
                        </li>
                        <li>
                            <div className="cursor-pointer h-12 w-12 bg-gray-400 rounded-full text-center text-white flex items-center justify-center text-3xl">
                            <p className="opacity-80">H</p>
                            </div>
                        </li>
            
                        <li>
                            <div className="cursor-pointer">
                            <img
                                src="/images/avatars/b.png"
                                alt=""
                            />
                            </div>
                        </li>
                        <li>
                            <div className="cursor-pointer">
                            <img
                                src="/images/avatars/l.png"
                                alt=""
                            />
                            </div>
                        </li>
                        <li>
                            <div className="cursor-pointer">
                            <img
                                src="/images/avatars/h.png"
                                alt=""
                            />
                            </div>
                        </li>
                        <li>
                            <div className="cursor-pointer h-12 w-12 bg-red-500 rounded-full text-center text-white flex items-center justify-center text-3xl">
                            <p className="opacity-80">Z</p>
                            </div>
                        </li>
                        <li>
                            <div className="cursor-pointer">
                            <img
                                src="/images/avatars/h.png"
                                alt=""
                            />
                            </div>
                        </li>
            
                        <li>
                            <div className="cursor-pointer">
                            <img
                                src="/images/brands/starbucks.png"
                                alt=""
                            />
                            </div>
                        </li>
                        <li>
                            <div className="cursor-pointer">
                            <img
                                src="/images/brands/stackoverflow.png"
                                alt=""
                            />
                            </div>
                        </li>
                        <li>
                            <div className="cursor-pointer">
                            <img
                                src="/images/brands/dribbble.png"
                                alt=""
                            />
                            </div>
                        </li>
                        <li>
                            <div className="cursor-pointer">
                            <img
                                src="/images/brands/digitalocean.png"
                                alt=""
                            />
                            </div>
                        </li>
                        <li>
                            <div className="cursor-pointer">
                            <img
                                src="/images/avatars/u.png"
                                alt=""
                            />
                            </div>
                        </li>
                        <li>
                            <div className="cursor-pointer">
                            <img
                                src="/images/avatars/y.png"
                                alt=""
                            />
                            </div>
                        </li>
                        <li>
                            <div className="cursor-pointer">
                            <img
                                src="/images/avatars/g.png"
                                alt=""
                            />
                            </div>
                        </li>
                        <li>
                            <div className="cursor-pointer">
                            <img
                                src="/images/avatars/d.png"
                                alt=""
                            />
                            </div>
                        </li>
                        <li>
                            <div className="cursor-pointer">
                            <img
                                src="/images/avatars/b.png"
                                alt=""
                            />
                            </div>
                        </li>
                        </ul>
                    </div>
            
                    <div className="messages bg-gray-50 dark:bg-zinc-900 -dark:bg-[#1e2126] -dark:bg-[#0d1115] -dark:bg-[#12171d] w-full relative overflow-y-auto h-screen">
                        <div className="h-auto">
                        <div className="search">
                            <div className="bg-gray-200 dark:bg-[#111] mx-4 my-4 flex items-center px-3 rounded-md">
                            <FiSearch size={23}
                                className="stroke-gray-500"
                            />
                            <input
                                placeholder="Search"
                                type="text"
                                className="w-full border-none bg-transparent p-3 outline-none"
                            />
                            </div>
                        </div>
            
                        <Dropdown />
                        
                        <Stories />
                       
                        <div className="h-[1px] bg-gray-300 dark:bg-gray-800 my-4"></div>
            
                        <div className="min-h-[400px]">
                            
                            <Channels />

                        </div>
            
                        {/* {/**<!-- FOOTER SIDEBAR--> **/}
                        <div className="sticky bottom-0 w-full px-4 bg-zinc-100 dark:bg-zinc-900 py-3">
                            <div className="flex justify-between items-center w-full">
                            <div className="flex gap-3 items-center cursor-pointer">
                                <div className="relative">
                                <img
                                    src="/images/avatars/3.png"
                                    className="h-10"
                                />
                                <div className="absolute right-0 bottom-0 rounded-full h-3 w-3 bg-green-500 border border-white border-2"></div>
                                </div>
                                <div>Scott</div>
                            </div>
                            <div className="flex gap-3">
                                <FiMic size={23}
                                className="text-gray-500 cursor-pointer"
                                />
                                <div // @click="phone = true"
                                >
                                <FiHeadphones size={23}
                                    className="text-gray-500 cursor-pointer"
                                />
                                </div>
                                <FiSettings size={23}
                                className="text-gray-500 cursor-pointer"
                                />
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
            </div>
        </React.Fragment>
    )
}

export default Sidebar;

export const Channels = () => {
    const {setConversation} = teamStore(state=>state)

    return (
      <React.Fragment>
        
        {teamChannels?.map((channel,i)=>{
        
        const [status, setStatus] = useState(true);
        const [selected, setSelected] = useState(true);

        const rooms = (
            <ul
            x-show="status"
            className="ml-4 mr-2 text-white"
        >
            {channel.list?.map((room,key)=> {
        
            return (
                <li 
                onClick={()=>{
                    setConversation(key)
                    setSelected(key)
                }}
                key={`room-${key}`}
                className={clx(
                {'flex bg-[#387aff] text-white px-3 pr-1 py-2 rounded-md justify-between items-center cursor-pointer':key==selected},
                {'hover:bg-gray-100 dark:hover:bg-black/30':key!=selected},
                "group flex pl-3 pr-1 py-2 rounded-md justify-between items-center cursor-pointer"  
                )}
                >
                <div className="flex gap-3 items-center">
                <FontAwesomeIcon icon={faHashtag}  
                    className={clx(
                        {'text-white':key==selected},
                        'text-gray-500')}
                />
                <div className={clx(
                    {'text-white':key==selected},
                    {'text-gray-700 dark:text-gray-400':key!=selected},
                    'font-medium ')}>{room.name}</div>
                </div>
                <div className={clx({'hidden':key!=selected},'flex gap-1')}>
                <FiUserPlus size={23}
                    className={clx({'text-white':key==selected},'h-4 text-gray-500')}
                    />
                <FiSettings size={23}
                    className={clx({'text-white':key==selected},'h-4 text-gray-500')}
                    />
                </div>
                {key!=selected && (
                <div className="hidden group-hover:flex flex gap-1">
                <FiPlus size={23}
                    className={clx({'text-white':key==selected},'h-4 text-gray-500')}
                />
                </div>
                )}
            </li>
            )
        })}
        </ul>
        )
        
        const audioRooms = (
            <ul
            x-show="status"
            className="mt-2 mx-6 mb-2"
        >
            {channel.list?.map((room,key)=> {
        
            return (
                <li class={clx(
                'hover:bg-gray-200 dark:hover:bg-black/30 p-1 rounded-md pr-0',
                'flex justify-between'
                )}>
                <div className="w-full flex flex-col justify-between 
                cursor-pointer text-gray-700 dark:text-gray-300">
                <div className="flex cursor-pointer">
                <FiVolume1 size={23}
                    className="text-gray-500 dark:text-gray-400"
                />
                <p className="text-gray-700 dark:text-gray-400">{room.name}</p>
                </div>
        
                {room.children?.length && (
                    <div>
                    {room.children?.map((user,i)=>(
                        <div className={clx(
                            {'pt-2': i==0},
                            {'pb-2': i!=room.children?.length-1},
                            `flex gap-2 items-center mx-6 cursor-pointer relative`
                        )}>
                            <img
                            src={user.avatar}
                            className="h-8 w-8 rounded-full border border-2 border-white"
                            />
                            <div className="text-gray-700 dark:text-gray-300">{user.name}</div>
                            <div className="absolute -right-10 flex items-center">
                            {user.video && (
                            <FiVideo size={23}
                            className="fill-gray-400 stroke-none h-4"
                            />
                            )}
                            </div>
                        </div>
                    ))}   
                </div>
                )}
                </div>
                {room.duration && ( <div className="text-xs text-gray-700 dark:text-gray-400 bg-zinc-200 dark:bg-zinc-800 p-1 rounded-md">{room.duration}</div>)}
            </li>
            )
            })}
        
            </ul>
        )


        
        const group = (
            <React.Fragment>
                <div className="mr-2">
                    <div className="flex justify-between gap-2 cursor-pointer text-gray-700 dark:text-gray-300">
                    <div
                        onClick={()=>setStatus(!status)}
                        className="flex items-center"
                    >
                    {status && <FiChevronDown size={23} className="h-5" /> }
                        {!status && <FiChevronRight size={23} className="h-5" /> }
                        <p>{channel.name}</p>
                    </div>
                    <div className="flex gap-1">
                        <FiPlus size={23}
                        className="h-5 text-gray-400"
                        />
                    </div>
                    </div>
                </div>
                {status && (
                    <React.Fragment>
                        {channel.type=='text' && rooms}
                        {channel.type=='voice' && audioRooms}
                    </React.Fragment>
                )}
            </React.Fragment>
        )
        
  return (
    <div 
      key={`channel-${i}`}
    >
      {group}
     
    </div>
  )
  })}
      </React.Fragment>
    )
}

export const Stories = () =>{
    const {open} = useModal(state=>state)
    const openStory = path => {
        open({type:'stories', values:{path}, styles:{
            // height:'max-content',
            // width:'fit-content',
        }})
    }
    return (
    <React.Fragment>
            <div className="flex justify-center overflow-x-hidden">
            <div className="flex gap-2">
              {Array.from(Array(6)).map((item,key)=>(
                  <div 
                  onClick={()=>openStory(key+1)}
                  class="p-[2px] h-12 w-12 cursor-pointer rounded-full bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500" >
                    <div 
                        style={{backgroundImage:`url(/images/demo/stories/${key+1}.png)`}}
                        class="bg-contain object-cover flex bg-zinc-300 dark:bg-zinc-600 border-white border-[2px] h-full w-full rounded-full items-center justify-center"></div>
                    </div>
              ))}
            
            </div>
        </div>
    </React.Fragment>
)
}
 
export const Dropdown = () => {
    const [status, setStatus] = useState(false)
    return (
        <div
        onClick={()=>setStatus(!status)}
            className="relative group flex items-center justify-center m-4 bg-gray-200 dark:bg-zinc-800 p-2 rounded-md cursor-pointer"
        >
            <div className="flex gap-3 items-center w-full">
            <img
                src="/images/avatars/d.png"
                className="h-12 object-contain"
            />
            <div className="">
                <div className="text-lg" > Jimmy </div>
                <div className="text-gray-400">active for chat</div>
            </div>

            <ul
                className={clx(status == true ? 'block' :'hidden', `w-auto absolute left-0 right-0 top-20 z-10 divide-y divide-zinc-300 
                dark:bg-zinc-800  
                dark:divide-zinc-700 dark:border-gray-700 
                -24 border bg-white  rounded-lg overflow-hidden text-sm dark:text-zinc-200`)}
            >
                   {[
                    {title:'Profile', icon: <FiUser size={23} className="h-4" /> },
                    {title:'Settings', icon: <FiSettings size={23} className="h-4" /> },
                    {title:'SettLog outings', icon: <FiLogOut size={23} className="h-4" /> },
                ].map(item=>(
                    <li>
                    <a
                        href="#"
                        className="hover:bg-zinc-100 dark:hover:bg-zinc-700 block px-4 py-3 dark:text-white flex items-center"
                    >
                        {item.icon}
                        <p>{item.title}</p>
                    </a>
                    </li>
                ))}

            </ul>
            </div>
            <div>
            {status && <FiChevronDown size={23} /> }
            {!status && <FiChevronRight size={23} /> }
            </div>
        </div>

    )
}